/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WatcherCredDto
 */
export interface WatcherCredDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof WatcherCredDto
     */
    said: string;
    /**
     * Credential SAD json
     * @type {string}
     * @memberof WatcherCredDto
     */
    sad: string;
    /**
     * SAID of the credential type - it is called Credential Schema
     * @type {string}
     * @memberof WatcherCredDto
     */
    schemaSaid: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof WatcherCredDto
     */
    issuerAid: string;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof WatcherCredDto
     */
    issueeAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof WatcherCredDto
     */
    alias?: string;
    /**
     * When the credential was revoked if it was revoked. Format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof WatcherCredDto
     */
    revokedAt?: string;
    /**
     * When the credential was updated for the last time. Format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof WatcherCredDto
     */
    updatedAt?: string;
    /**
     * Any additional credential details. Usually it is credentials cesr
     * @type {string}
     * @memberof WatcherCredDto
     */
    details?: string;
}

/**
 * Check if a given object implements the WatcherCredDto interface.
 */
export function instanceOfWatcherCredDto(value: object): boolean {
    if (!('said' in value)) return false;
    if (!('sad' in value)) return false;
    if (!('schemaSaid' in value)) return false;
    if (!('issuerAid' in value)) return false;
    return true;
}

export function WatcherCredDtoFromJSON(json: any): WatcherCredDto {
    return WatcherCredDtoFromJSONTyped(json, false);
}

export function WatcherCredDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatcherCredDto {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'],
        'sad': json['sad'],
        'schemaSaid': json['schemaSaid'],
        'issuerAid': json['issuerAid'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'alias': json['alias'] == null ? undefined : json['alias'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function WatcherCredDtoToJSON(value?: WatcherCredDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'sad': value['sad'],
        'schemaSaid': value['schemaSaid'],
        'issuerAid': value['issuerAid'],
        'issueeAid': value['issueeAid'],
        'alias': value['alias'],
        'revokedAt': value['revokedAt'],
        'updatedAt': value['updatedAt'],
        'details': value['details'],
    };
}

